import type {
  GameInput,
  RuleContext,
  RuleOutcome,
  RuleSet,
  RuleSetup,
  StepResult,
} from './contracts';

/**
 * The placeholder that makes the whole pipeline runnable before any rules exist.
 *
 * It is a null object, not a game: it accepts every input, changes nothing,
 * emits no transitions and never ends. Its only job is to let the room, the
 * modes, the renderer and the persistence path be wired up and exercised end to
 * end today. Delete it — or keep it as the fixture that proves a mode works
 * independently of its rules — once a real ruleset lands.
 */

export interface NullState {
  /** How many inputs have been accepted. Not a score. */
  readonly steps: number;
}

export const NULL_RULE_SET_ID = 'null';

export const nullRuleSet: RuleSet<NullState, void> = {
  id: NULL_RULE_SET_ID,
  version: 0,

  createInitialState(_setup: RuleSetup<void>): NullState {
    return { steps: 0 };
  },

  reduce(state: NullState, _input: GameInput, _ctx: RuleContext): StepResult<NullState> {
    return {
      state: { steps: state.steps + 1 },
      transitions: [],
      events: [],
      terminal: false,
    };
  },

  isTerminal(_state: NullState): boolean {
    return false;
  },

  summarize(_state: NullState): RuleOutcome {
    return { scores: [], winners: [], stats: [] };
  },
};
